// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import InfoCircle14 from './InfoCircle14';
import InfoCircle14Filled from './InfoCircle14Filled';
import InfoCircle20 from './InfoCircle20';
import InfoCircle20Filled from './InfoCircle20Filled';
import InfoCircle24 from './InfoCircle24';
import InfoCircle24Filled from './InfoCircle24Filled';
import InfoCircle40 from './InfoCircle40';
import InfoCircle40Filled from './InfoCircle40Filled';
import InfoCircle48 from './InfoCircle48';
import InfoCircle48Filled from './InfoCircle48Filled';

type InfoCircleProps = {
    variation:
        | '14'
        | '14Filled'
        | '20'
        | '20Filled'
        | '24'
        | '24Filled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    InfoCircle14,
    InfoCircle14Filled,
    InfoCircle20,
    InfoCircle20Filled,
    InfoCircle24,
    InfoCircle24Filled,
    InfoCircle40,
    InfoCircle40Filled,
    InfoCircle48,
    InfoCircle48Filled,
};

const InfoCircle: FC<InfoCircleProps> = ({ variation, ...props }) => {
    const variationKey = `InfoCircle${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"InfoCircle" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default InfoCircle;
